import request from '@/http/request';

export function getServerMoveList(data) {
    return request({
      url: '/api/v1/ops/get_serverMove_alltk_info',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

export function UpdateServerMoveList(data) {
    return request({
      url: '/api/v1/ops/update_serverMove_alltk_info',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

/** 服务器故障工单（GetTicketList_Fault）列表 */
export function getServerFaultList(data) {
  return request({
    url: '/api/v1/ops/get_serverFault_alltk_info',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function getDcopsFaultCampusOptions() {
  return request({
    url: '/api/v1/ops/dcops_fault_campus_options',
    method: 'get',
  });
}

/** 从 Dcops 拉取故障工单并入库；body 可空，后端默认同步上月～当月 */
export function UpdateServerFaultList(data) {
  return request({
    url: '/api/v1/ops/update_serverFault_alltk_info',
    method: 'post',
    data: data || {},
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function getServerRetireList(data) {
  return request({
    url: '/api/v1/ops/get_serverRetire_alltk_info',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function getDcopsRetireCampusOptions() {
  return request({
    url: '/api/v1/ops/dcops_retire_campus_options',
    method: 'get',
  });
}

export function UpdateServerRetireList(data) {
  return request({
    url: '/api/v1/ops/update_serverRetire_alltk_info',
    method: 'post',
    data: data || {},
    headers: {
      'Content-Type': 'application/json',
    },
  });
}